import { render, staticRenderFns } from "./ModalRecebimento.vue?vue&type=template&id=4f5670d0&scoped=true"
import script from "./ModalRecebimento.vue?vue&type=script&lang=ts"
export * from "./ModalRecebimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalRecebimento.vue?vue&type=style&index=0&id=4f5670d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5670d0",
  null
  
)

export default component.exports